import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import { $t } from 'src/tools';
import HistoryModal from './history';

interface IProps {
  loading: boolean;
  source: {
    list: any;
    total: number;
  };
  type: string[];
  dispatch: (props: any) => void;
  query: Record<string, number>;
  onChange: (r: Record<string, number>) => {};
}
const initialState = { visible: false };
type State = Readonly<typeof initialState>;

class ImportWrapper extends PureComponent<IProps, State> {
  state = initialState;

  render() {
    const { loading, source, query } = this.props;
    const { visible } = this.state;

    return (
      <>
        <Button type="link" onClick={this.handleToggle(true)}>{$t('export_history', 'Sider')}</Button>
        <HistoryModal
          modalProps={{
            visible,
            width: 800,
            title: $t('export_history', 'Sider'),
            maskClosable: false,
            bodyStyle: { paddingBottom: 0 },
            footer: (
              <>
                <Button type="primary" onClick={() => this.handleChange(query)}>
                  {$t('order_refreshCart', 'ImportExport')}
                </Button>
                <Button onClick={this.handleToggle(false)}>{$t('close', 'ImportExport')}</Button>
              </>
            ),
          }}
          query={query}
          source={source}
          loading={loading}
          onChange={this.handleChange}
          onClose={this.handleToggle(false)}
        />
      </>
    );
  }
  handleOpen = () => {
    this.props.dispatch({ type: 'down/setState', payload: { visible: true, temp: 0 } });
  };
  // Modal 开关
  handleToggle = (visible: boolean) => {
    return () => {
      this.setState({ visible });
      if (!visible) {
        this.props.dispatch({
          type: 'down/setState',
          payload: { source: { list: [], total: 0 } },
        });
      }
    };
  };
  // modal 请求内容更新
  handleChange = (query: Record<string, number>) => {
    const { dispatch, type } = this.props;
    dispatch({
      type: 'down/fetchImportList',
      payload: { type: 'excel', ...query, task_type: type.join() },
    });
  };
}

export default connect(({ downState }: any) => ({ ...downState }))(ImportWrapper);
